import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, CardMedia } from "@mui/material";
import { getFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";
import useTranslation from "../hooks/traslation";

interface AddCategoryModalProps {
  name: string;
  price: string;
  image: string;
  open: boolean;
  selectedId: string;
  onClose: () => void;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  description: string;
  setDescriptionAr: Dispatch<SetStateAction<string>>;
  setNameAr: Dispatch<SetStateAction<string>>;
  nameAr: string;
  descriptionAr: string;
}

export default function CategoryDetails({
  setOpen,
  open,
  name,
  price,
  image,
  selectedId,
  onClose,
  setSelectedId,
  description,
  descriptionAr,
  nameAr,
  setDescriptionAr,
  setNameAr,
}: AddCategoryModalProps) {
  const isViewMode = Boolean(selectedId); // disable fields if selectedId is present
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{translate?.main?.categoryDetail}</h2>
            <div
              className="btn-close"
              onClick={() => {
                setSelectedId("");
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            {image && (
              <div className="control_group">
                <label>{translate?.main?.categoryImg}</label>
                <CardMedia
                  component="img"
                  image={image}
                  alt="Category"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              </div>
            )}
            <div className="control_group">
              <label>{translate?.main?.categoryName}</label>
              <TextField
                placeholder={translate?.user?.enterCategoryName}
                fullWidth
                value={name}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
            <div className="control_group">
              <label>Category Name Arabic</label>
              <TextField
                placeholder="Category Name Arabic"
                fullWidth
                value={nameAr}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>

            {description ? (
              <div className="control_group">
                <label>{translate?.globals?.description}</label>
                <TextField
                  placeholder={translate?.globals?.description}
                  fullWidth
                  value={getLang === "en" ? description : descriptionAr}
                  hiddenLabel
                  disabled={isViewMode}
                  multiline
                  maxRows={5}
                  minRows={5}
                />
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </Modal>
  );
}
